import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';

const MAX_ERROR_STACK_LENGTH = 100000;

export const parseHydrationErrorInfo = ({ componentStack }) => {
	const errorStackLogLen = StatsigConfigurations.getNumber(
		'confluence_hydration_error_log_config',
		0,
	);
	if (errorStackLogLen <= 0 || !componentStack) {
		return '';
	}
	const clampedErrorStackLog = Math.min(MAX_ERROR_STACK_LENGTH, errorStackLogLen);
	return componentStack.toString().substring(0, clampedErrorStackLog) ?? '';
};
